import { styled } from '@mui/system';
import { theme } from 'oems/theme';
import { Stack as StackMUI } from '@mui/material';
export const H4 = styled('h4')`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18.75px;
  color: ${theme.palette.text.dark};
  margin: 0;
  margin-left: 10px;
`;
